import React from "react";
import styles from "./SegmentedControl.module.scss";

export interface ISegmentOption {
  id: string;
  label: string;
}

interface IProps {
  value: string;
  options: ISegmentOption[];
  onChange(id: string): void;
}

const SegmentedControl: React.FC<IProps> = ({ value, options, onChange }) => {
  return (
    <div className={styles.control} role="tablist">
      {options.map((option) => (
        <button
          key={option.id}
          type="button"
          role="tab"
          aria-selected={option.id === value}
          className={option.id === value ? styles.selected : styles.option}
          onClick={() => onChange(option.id)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default SegmentedControl;
